<template>
  <div :class="$vssWidth > 1270 ? 'content' : 'content2'">

    <div class="etapas">
      <input type="submit" class="btn-inativo" value="1" />
      <div class="linha"></div>
      <input type="submit" class="btn-inativo" value="2" />
      <div class="linha"></div>
      <input type="submit" class="btn-ativo" value="3" />
    </div>

    <div class="etapas-titulo">
      <p class="p-inativo">Etapa 1:<br>login ou cadastro</p>
      <div class="linha-espaco"></div>
      <p class="p-inativo">Etapa 2:<br>pagamento</p>
      <div class="linha-espaco"></div>
      <p class="p-ativo">Etapa 3:<br>concluído</p>
    </div>

<!--
    <div class="conclusao">
      <p>Pedido Efetuado com sucesso</p>
      <p>Número do seu pedido #{{$store.state.finalizarCompra.idPedido}}</p>
    </div>
-->

        <div v-if="pagamentos.length > 0" class="cadastro">

          <div class="div-atuacao">

            <p class="titulo">COMPRA EFETUADA COM SUCESSO</p>

            <p class="descricao">
              <span class="bold">{{$store.state.usuario.usuario.PrimeiroNome}}</span> obrigado pela parceria com o Ilha!!<br>
              Apresente o QRCode da promoção ou o seu nome na data e unidade que você escolheu.
            </p>
            <div v-if="compras.length > 0">
            <div class="compras-titulo">
              <span></span>
              <span>Produto / Preço Promocional</span>
              <span>Qtd</span>
              <span>Data/Unidade</span>
              <span></span>
            </div>

            <div v-for="compra in compras" :key="compra.id" class="compras">
                <div class="produto-imagem">
                  <img :src="compra.ProdutoUrlImagens" />
                </div>
                <div class="produto-titulo">
                    <span class="bold">{{ compra.ProdutoTitulo }}</span>
                    <span>{{ compra.PrecoPromocional | numeroPreco }}</span>
                    <span class="codigo-id">Pedido: {{ compra.CodigoPedido.substring(compra.CodigoPedido.length - 6)}}</span>
                </div>
                <div class="produto-quantidade">
                    1 und
                </div>
                <div class="produto-data-horario azul">
                    <span>{{compra.SemData === true ? 'Qualquer data' : new Date(compra.DataPromocao.toDate().toISOString()) | moment("ddd, DD/MM")}}</span>
                    <span>{{compra.Horario}}</span>
                    <span class="bold">{{ compra.Unidade }}</span>
                </div>
                <div v-if="compra.StatusPromocao == 'Consumida'" class="status">
                    {{ compra.StatusPromocao }}
                </div>
                <div v-else class="qr-code">
                  <qrcode-vue :value="compra.valorQrCode" :size="100"></qrcode-vue>
                </div>

            </div>
            <div v-if="pagamentos[0].Cupom">
              Cupom utilizado: {{pagamentos[0].Cupom}} - R${{pagamentos[0].CupomValor}}
            </div>
            </div>
            <div class="total" v-if="pagamentos[0].Total != null">
              Valor total da compra {{pagamentos[0].Total | numeroPreco}} / {{pagamentos[0].FormaPgto.replace('GetNet ', '')}}
            </div>
            </div>
        </div>
  </div>
</template>
<script>
import { db } from '@/firebase.js'
import { mapActions } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import VueScreenSize from 'vue-screen-size'
import _ from 'lodash'

export default {
  name: 'Conclusao',
  mixins: [VueScreenSize.VueScreenSizeMixin],
  props: ['id'],
  components: {
    QrcodeVue
  },
  data: function () {
    return {
      usuario: '',
      compras: [],
      pagamentos: []
    }
  },
  created () {
    this.limparFinalizarCompraMenu()
    this.getCompras()
  },
  methods: {
    ...mapActions('carrinho', ['limparCarrinho']),
    ...mapActions('menu', ['finalizacaoPedido', 'toggleMenu']),
    limparFinalizarCompraMenu () {
      this.limparCarrinho()
      this.toggleMenu(false)
      this.finalizacaoPedido(false)
    },
    getUsuario () {
      this.usuario = JSON.parse(localStorage.getItem('usuarioAtual'))
      this.getCompras()
    },
    async getCompras () {
      await db.collection('Pagamentos').doc(this.id).get().then((doc) => {
        this.pagamentos.push(doc.data())
        this.getPromocoes()
      })
    },
    getPromocoes () {
      let loader = this.$loading.show({
        container: null,
        fullPage: true,
        color: '#F85E28',
        loader: 'spinner',
        width: 100,
        height: 100,
        backgroundColor: '#ffffff',
        opacity: 0.5,
        zIndex: 999
      })
      db.collection('Clientes')
        .doc(this.$store.state.usuario.usuario.Email)
        .collection('Compras')
        .where('CodigoPedido', '==', this.pagamentos[0].CodigoPedido)
        .orderBy('DataPromocao', 'asc')
        .onSnapshot((querySnapshot) => {
          querySnapshot.docChanges().forEach((change) => {
            if (change.type === 'added') {
              var compra = change.doc.data()
              compra.id = change.doc.id
              compra.valorQrCode = change.doc.id + this.$store.state.usuario.usuario.id
              this.compras.push(compra)
              this.compras = _.sortBy(this.compras, o => [o.DataPromocao, o.Horario, o.Titulo]).reverse()
              loader.hide()
            }
          })
        })
    }
  }
}
</script>

<style scoped>
.content, .content2 {
  max-width: 1174px;
  margin: 0 auto;
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
  grid-template-areas:
    "etapas"
    "etapas-titulo"
    "cadastro"
}

.content {
  padding: 40px;
}

.content2 {
  padding: 40px 0 40px 0;
}

@media (max-width: 1000px) {
  .content2 {
    margin: 0;
    padding: 20px 10px;
    grid-template-columns: 100%;
  }
}

/* CADASTRO */
.cadastro {
  grid-area: cadastro;
  background: #fff;
  box-shadow: 5px 5px 15px 0px rgba(44, 44, 44, 0.15);
  padding: 10px 20px 25px 20px;
  width: 80%;
  justify-self: center;
}

.compras-titulo {
  grid-template-columns: 120px 2fr 1fr 2fr 1fr;
  display: grid;
  font-size: 0.8rem;
  font-weight: 600;
  background: #f3f3f3;
  padding: 10px 0;
}

.compras-titulo {
  grid-template-columns: 120px 2fr 1fr 2fr 1fr;
  display: grid;
  font-size: 0.8rem;
  font-weight: 600;
  background: #f3f3f3;
  padding: 10px 0;
}

.compras-titulo span {
  margin: 0 auto;
}

.compras {
  display: grid;
  grid-template-columns: 120px 2fr 1fr 2fr 1fr;
  gap: 20px;
  padding: 20px 0 20px 0;
  align-content: center;
  align-items: center;
  border-bottom: 1px solid #f3f3f3;
}

.status {
  font-size: 0.9em;
  font-weight: 600;
  color: #21c25e;
}

.div-atuacao {
  margin: 0 0 20px 0;
}

.outer-div {
  height: 81px;
  width: 120px;
  overflow: hidden;
  grid-row: span 2;
  margin: 5px 0 0 0;
}

.inner-div {
  height: 100%;
  width: 100%;
  background-size: cover;
  background-position: center;
  transition: all 0.7s ease;
  grid-row: span 2;
}

.inner-div:hover {
  transform: scale(1.1);
}

.titulo {
  font-size: 1.2rem;
  color: #2E9189;
  font-weight: 600;
  border-bottom: 1px solid #2E9189;
  padding: 5px 0;
  margin: 0 0 15px 0;
}

.descricao {
  font-size: 1rem;
  color: #2E9189;
  padding: 5px 0;
  margin: 0 0 15px 0;
}
.total {
  padding: 20px;
  font-weight: 500;
  font-size: 1.2em;
  color: #666;
}

.produto-titulo {
  display: grid;
  gap: 5px;
}

.produto-imagem img{
  width: 120px;
}

.produto-data-horario {
  display: grid;
  gap: 5px;
}

.azul {
  color: #00f;
}

.codigo-id {
  font-size: 0.9em;
}

@media (max-width: 960px) {
  .cadastro {
    padding: 10px 20px 25px 20px;
    width: 100%;
    justify-self: center;
  }
  .compras {
    grid-template-columns: 1fr;
    margin-top: 20px;
    border-bottom: 1px solid #666;
  }
  .compras-titulo {
    display: none;
  }
  .produto-quantidade {
    display: none;
  }
  .produto-imagem img{
    width: 98%;
  }
  .produto-data-horario {
    display: flex;
    justify-content: center;
  }
  .produto-data-horario span {
    padding: 0 0 0 20px;
  }
  .qr-code {
    max-width: 80%;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Conclusao.vue